import { IPlanEnrollment } from "../../../services/api/planEnrollment/types";

export const selectorAvailablePlanEnrollments = (
  planEnrollments: IPlanEnrollment[],
  now: Date
): IPlanEnrollment[] => {
  return planEnrollments.filter(
    planEnrollment => !planEnrollment.endDate || planEnrollment.endDate > now
  );
};
